import React, { useEffect, useState } from "react";

import { View } from "react-native";
import Text from "component/typography/Text";
import {
  Cursor,
  CodeField,
  useBlurOnFulfill,
  useClearByFocusCell,
} from "react-native-confirmation-code-field";

import { colors } from "asset/constant";
import { css } from "style";
import { mq } from "utils";

const VERIFY_CODE_LENGTH = 5;

const FIELD_WIDTH = mq(30);
const MARGIN = mq(15);
const ROOT_WIDTH =
  VERIFY_CODE_LENGTH * FIELD_WIDTH + mq((VERIFY_CODE_LENGTH - 1) * MARGIN);

export default function CodeInput(props: {
  code?: string;
  getValue: (inputCode: string) => void;
}) {
  const { getValue, code = "" } = props;

  const [value, setValue] = useState(code);

  useEffect(() => {
    setValue(code);
  }, [code]);

  const ref = useBlurOnFulfill({ value, cellCount: VERIFY_CODE_LENGTH });
  const [codeFieldProps, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue,
  });

  return (
    <CodeField
      ref={ref}
      {...codeFieldProps}
      value={value}
      onChangeText={(inputCode) => {
        setValue(inputCode);
        getValue && getValue(inputCode);
      }}
      cellCount={VERIFY_CODE_LENGTH}
      rootStyle={{ width: ROOT_WIDTH }}
      keyboardType="number-pad"
      textContentType="oneTimeCode"
      autoFocus
      renderCell={({ index, symbol, isFocused }) => (
        <View
          style={{
            ...css.width(30),
            ...css.height(35),
            ...css.centralElements,
            borderBottomWidth: isFocused ? mq(2) : mq(1),
            borderBottomColor: isFocused ? colors.theme : colors.text.muted,
          }}
          key={index + ""}
          onLayout={getCellOnLayoutHandler(index)}
        >
          <Text align="center" size={"xxl"} weight="medium">
            {symbol || (isFocused ? <Cursor /> : null)}
          </Text>
        </View>
      )}
    />
  );
}
